module.exports = __webpack_public_path__ + "static/img/jcyy-content-tab-3.ad03cdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/chartTexeraJc/jcyy-content-tab-3.png
// module id = lwDO
// module chunks = 34